module.exports = __webpack_public_path__ + "static/media/empty-favorites-placeholder-dark.6a1745f7.svg";